import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { map, startWith } from 'rxjs/operators';
import { CorporationService } from 'src/app/services/corporation.service';
import { GlobalService } from 'src/app/services/global.service';
import { CarService } from 'src/app/services/triggers/car.service';
import { CorporateService } from 'src/app/services/triggers/corporate.service';
import { CorporationSegmentAddCorporationComponent } from './corporation-segment-add-corporation/corporation-segment-add-corporation.component';

@Component({
  selector: 'app-corporation-segments-edit',
  templateUrl: './corporation-segments-edit.component.html',
  styleUrls: ['./corporation-segments-edit.component.css']
})
export class CorporationSegmentsEditComponent implements OnInit {
  segmentForm: FormGroup = new FormGroup({
    id: new FormControl(null),
    name: new FormControl(null),
    price: new FormControl(null),
    items: new FormArray([]),
  });
  header: string = "Add";
  loading: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private corporationService: CorporateService,
    private globalService: GlobalService,
    private dialogRef: MatDialogRef<CorporationSegmentsEditComponent>,
  ) { }

  ngOnInit(): void {
    if(this.data != null) {
      this.header = "Edit";
      this.getCorporationSegment();
    }
  }

  getCorporationSegment(): void {
    this.corporationService.getCorporationSegment(this.data).subscribe(result => {
      var data = result.data.data;
      this.segmentForm.patchValue(data);
      const items = this.segmentForm.get('items') as FormArray
      items.clear();
      for (let i = 0; i < data.items.length; i++) {
        const element = data.items[i];
        items.push(new FormControl(element));
      }
    }, this.globalService.handleError);
  }

  onSubmit(): void {
    this.corporationService.addOrEditCorporationSegmentType(this.segmentForm).subscribe(result => {
      this.globalService.successMessage(result);
      this.dialogRef.close(true);
    }, this.globalService.handleError)
  }

  addItem(): void {
    this.dialog.open(CorporationSegmentAddCorporationComponent, {
      minWidth: '400px',
      autoFocus: false,
      data: this.data
    }).afterClosed().subscribe(data => {
      if(data) {
        this.getCorporationSegment();
      }
    });

  }

  removeItem(item: any): void {
    this.corporationService.corporationSegmentRemoveCorporation(this.data, item).subscribe(result => {
      this.getCorporationSegment();
      this.globalService.successMessage(result);
    }, this.globalService.handleError);
  }

  displayFn(data: any): string {
    return data?.name ? data.name : '';
  }

  private _filter(value: any, data: any): string[] {
    const filterValue = value.name ? value.name.toLowerCase():value.toLowerCase();
    return data.filter(option => option?.name?.toLowerCase().includes(filterValue));
  }

  delete(id: number): void {
    if(confirm('Are you sure ?')) {
      this.corporationService.deleteCorporationSegment(id).subscribe(result => {
        this.globalService.successMessage(result);
        this.dialogRef.close(true);
      }, this.globalService.handleError);
    }
  }

}
